import {
    GET_DEVICES_DATA,
    UPDATE_DEVICES_DATA,
    DELETE_DEVICES_DATA,
    GET_DEVICES_PING_STATUS,
    DEVICE_ONBOARDING,
    TOGGLE_DEVICES_MONITORING_STATUS,
    GET_DEVICES_DASHBOARD_DATA,

} from './actionTypes';

export const getDevicesDataInit = (storeCodes) => ({
    type: GET_DEVICES_DATA.INIT,
    storeCodes
});

export const getDevicesDataSuccess = (data) => ({
    type: GET_DEVICES_DATA.SUCCESS,
    payload: data
});

export const getDevicesDataError = (error) => ({
    type: GET_DEVICES_DATA.ERROR,
    payload: error
});

export const updateDevicesDataInit = (deviceData) => ({
    type: UPDATE_DEVICES_DATA.INIT,
    payload: deviceData
});

export const updateDevicesDataSuccess = (response) => ({
    type: UPDATE_DEVICES_DATA.SUCCESS,
    payload: response
});

export const updateDevicesDataError = (error) => ({
    type: UPDATE_DEVICES_DATA.ERROR,
    payload: error
});

export const clearUpdateDevicesData = () => ({ type: UPDATE_DEVICES_DATA.CLEAR });

export const deleteDevicesDataInit = (deviceId) => ({
    type: DELETE_DEVICES_DATA.INIT,
    deviceId
});

export const deleteDevicesDataSuccess = () => ({
    type: DELETE_DEVICES_DATA.SUCCESS
});

export const deleteDevicesDataError = (error) => ({
    type: DELETE_DEVICES_DATA.ERROR,
    payload: error
});

export const clearDeleteDevicesData = () => ({ type: DELETE_DEVICES_DATA.CLEAR });

export const getDevicesPingStatusInit = (storeCodes) => ({
    type: GET_DEVICES_PING_STATUS.INIT,
    storeCodes
});

export const getDevicesPingStatusSuccess = (data) => ({
    type: GET_DEVICES_PING_STATUS.SUCCESS,
    payload: data
});

export const getDevicesPingStatusError = (error) => ({
    type: GET_DEVICES_PING_STATUS.ERROR,
    payload: error
});

export const toggleDevicesMonitoringStatusInit = (deviceId) => ({
    type: TOGGLE_DEVICES_MONITORING_STATUS.INIT,
    deviceId
});

export const toggleDevicesMonitoringStatusSuccess = () => ({
    type: TOGGLE_DEVICES_MONITORING_STATUS.SUCCESS
});

export const toggleDevicesMonitoringStatusError = (error) => ({
    type: TOGGLE_DEVICES_MONITORING_STATUS.ERROR,
    payload: error
});

export const clearToggleDevicesMonitoringStatus = () => ({ type: TOGGLE_DEVICES_MONITORING_STATUS.CLEAR });

export const deviceOnboardingInit = (deviceData) => ({
    type: DEVICE_ONBOARDING.INIT,
    payload: deviceData
});

export const deviceOnboardingSuccess = (response) => ({
    type: DEVICE_ONBOARDING.SUCCESS,
    payload: response
});

export const deviceOnboardingFailure = (error) => ({
    type: DEVICE_ONBOARDING.ERROR,
    payload: error
});

export const deviceOnboardingClear = () => ({ type: DEVICE_ONBOARDING.CLEAR });

export const getDevicesDashboardDataInit = (params) => ({
    type: GET_DEVICES_DASHBOARD_DATA.INIT,
    params
});

export const getDevicesDashboardDataSuccess = (data) => ({
    type: GET_DEVICES_DASHBOARD_DATA.SUCCESS,
    payload: data
});

export const getDevicesDashboardDataError = (error) => ({
    type: GET_DEVICES_DASHBOARD_DATA.ERROR,
    payload: error
});

export const clearDevicesData = () => ({ type: GET_DEVICES_DATA.CLEAR });

export const clearDashboardData = () => ({ type: GET_DEVICES_DASHBOARD_DATA.CLEAR });

export const clearPingStatusData = () => ({ type: GET_DEVICES_PING_STATUS.CLEAR });
